type TCallback = (e: ErrorEvent | PromiseRejectionEvent) => void

/**
 * Https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event.
 * @param callback - Errornál megfutó callback.
 */
export default function onUnhandledRejection (callback: TCallback): void {
  /**
   * Placeholder függvény, amit el lehet távolítani.
   * @param ev - A hibaesemény.
   */
  function fn (ev: ErrorEvent | PromiseRejectionEvent): void {
    callback(ev)

    window.removeEventListener('unhandledrejection', fn)
  }

  window.addEventListener('unhandledrejection', fn)
}
